import { render, staticRenderFns } from "./greenChannel.vue?vue&type=template&id=63304610&scoped=true&"
import script from "./greenChannel.vue?vue&type=script&lang=js&"
export * from "./greenChannel.vue?vue&type=script&lang=js&"
import style0 from "./greenChannel.vue?vue&type=style&index=0&id=63304610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63304610",
  null
  
)

export default component.exports